import React, { useState, useEffect, Fragment } from "react";
import { useHistory, useParams } from "react-router-dom";
import { useLazyQuery, useMutation } from "@apollo/react-hooks";
import {
  Divider,
  Box,
  Typography,
  makeStyles,
  TextField,
  Container,
  CircularProgress,
  useMediaQuery,
} from "@material-ui/core";
import { TimePicker, DatePicker } from "@material-ui/pickers";
import gql from "graphql-tag";
import { useForm, Controller } from "react-hook-form";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader

import { propertyDataArray } from "../components/PropertyDataArray";
import Grid from "../components/Grid";
import { Card, CardContent, CardActions } from "../components/Card";
import moment from "moment";
import Button from "../components/Button";
import Table from "../components/Table";
import { Select, TextInput } from "../components/Form";
import { useAlert } from "../components/Alert";
import LoadingModal from "../components/LoadingModal";

const GET_FORECLOSURE = gql`
  query foreclosure($obj_no: Int!) {
    foreclosure(obj_no: $obj_no) {
      obj_no
      obj_court
      obj_city
      obj_area
      obj_section
      obj_section_s
      obj_landno
      obj_address
      obj_creditor
      obj_debtor
      obj_type
      obj_patterns
      obj_date_ymd
      obj_date_hi
      obj_time
      obj_total_floor
      obj_land_floor
      obj_build_floor
      obj_s_floor
      obj_add_floor
      obj_c_floor
      obj_margin
      obj_price
      obj_land_data
      obj_build_data
      obj_bulletin_data
      obj_another
      obj_caseno
      obj_debtor
      obj_share
      obj_str
      obj_link
      obj_creditor
      images {
        id
        imageUrl
      }
    }
  }
`;
const SAVE_FORECLOSURE = gql`
  mutation saveForeclosure($foreclosureInput: ForeclosureInput!) {
    saveForeclosure(foreclosureInput: $foreclosureInput)
  }
`;
const SAVE_EDITPROPERTYRECORD = gql`
  mutation saveEditPropertyRecord(
    $foreclosureId: Int!
    $editProperty: String!
    $editLog: String!
  ) {
    saveEditPropertyRecord(
      foreclosureId: $foreclosureId
      editProperty: $editProperty
      editLog: $editLog
    )
  }
`;

export default function SaleObjDetailEdit() {
  const useStyles = makeStyles({
    DocumentContainerCenter: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      minWidth: "100px",
    },
  });
  const classes = useStyles();
  const isTable = useMediaQuery("(min-width:768px)");
  const Alert = useAlert();
  const { id } = useParams();
  const { courtArray, typeArray } = propertyDataArray();
  const [foreclosureId, setForeclosureId] = useState();
  const { control, handleSubmit, setValue, watch, getValues } = useForm({
    defaultValues: {
      obj_no: Number(id),
      obj_city: "",
      obj_area: "",
      obj_section: "",
      obj_section_s: "",
      obj_landno: "",
      obj_address: "",
      obj_creditor: "",
      obj_debtor: "",
      obj_type: "",
      obj_patterns: "",
      obj_date_ymd: null,
      obj_date_hi: null,
      obj_time: "",
      obj_total_floor: "",
      obj_land_floor: "",
      obj_build_floor: "",
      obj_s_floor: "",
      obj_add_floor: "",
      obj_c_floor: "",
      obj_margin: "",
      obj_price: "",
      obj_land_data: "",
      obj_build_data: "",
      obj_bulletin_data: "",
    },
  });
  const objType = watch("obj_type");
  useEffect(() => {
    if (id) {
      getForeclosures({
        variables: {
          obj_no: Number(id),
        },
      });
    }
  }, [id]);
  const [newData, setNewData] = useState([]);
  const [getForeclosures, { data, loading }] = useLazyQuery(GET_FORECLOSURE, {
    fetchPolicy: "network-only",
    notifyOnNetworkStatusChange: true,
    onCompleted({ foreclosure }) {
      if (foreclosure) {
        let newData = [];
        newData.push({
          obj_type: foreclosure.obj_type,
          obj_date_ymd: foreclosure.obj_date_ymd,
          obj_date_hi: foreclosure.obj_date_hi,
          obj_time: foreclosure.obj_time,
          obj_total_floor: foreclosure.obj_total_floor,
          obj_land_floor: foreclosure.obj_land_floor,
          obj_build_floor: foreclosure.obj_build_floor,
          obj_s_floor: foreclosure.obj_s_floor,
          obj_add_floor: foreclosure.obj_add_floor,
          obj_c_floor: foreclosure.obj_c_floor,
          obj_margin: foreclosure.obj_margin,
          obj_price: foreclosure.obj_price,
        });

        setForeclosureId(foreclosure.obj_no);
        setNewData(newData);
        setValue("obj_creditor", foreclosure.obj_creditor);
        setValue("obj_debtor", foreclosure.obj_debtor);
        setValue("obj_type", foreclosure.obj_type);
        setValue("obj_city", foreclosure.obj_city);
        setValue("obj_area", foreclosure.obj_area);
        setValue("obj_address", foreclosure.obj_address);
        setValue("obj_section", foreclosure.obj_section);
        setValue("obj_section_s", foreclosure.obj_section_s);
        setValue("obj_landno", foreclosure.obj_landno);
        setValue("obj_patterns", foreclosure.obj_patterns);
        setValue("obj_date_ymd", foreclosure.obj_date_ymd);
        setValue("obj_date_hi", foreclosure.obj_date_hi);
        setValue("obj_time", foreclosure.obj_time);
        setValue("obj_total_floor", foreclosure.obj_total_floor);
        setValue("obj_land_floor", foreclosure.obj_land_floor);
        setValue("obj_build_floor", foreclosure.obj_build_floor);
        setValue("obj_s_floor", foreclosure.obj_s_floor);
        setValue("obj_add_floor", foreclosure.obj_add_floor);
        setValue("obj_c_floor", foreclosure.obj_c_floor);
        setValue("obj_margin", foreclosure.obj_margin);
        setValue("obj_price", foreclosure.obj_price);
        setValue("obj_land_data", foreclosure.obj_land_data);
        setValue("obj_build_data", foreclosure.obj_build_data);
        setValue("obj_bulletin_data", foreclosure.obj_bulletin_data);
      }
    },
    onError(error) {
      Alert.alert("通知", `${error}`, [
        {
          text: "確定",
          type: "ok",
        },
      ]);
    },
  });

  const [saveForeclosure, { loading: saveForeclosureLoading }] = useMutation(
    SAVE_FORECLOSURE,
    {
      onCompleted({ saveForeclosure }) {
        if (saveForeclosure) {
          Alert.alert("", "儲存成功", [
            {
              text: "確定",
              onPress: () => {
                getForeclosures({
                  variables: {
                    obj_no: Number(id),
                  },
                });
              },
              type: "ok",
            },
          ]);
        } else {
          Alert.alert("", "儲存失敗，請再次嘗試。", [
            { text: "確定", type: "ok" },
          ]);
        }
      },
      onError(error) {
        Alert.notice(`${error.message.replace("GraphQL error: ", "")}`);
      },
    }
  );

  const [saveEditPropertyRecord, { loading: saveEditPropertyRecordLoading }] =
    useMutation(SAVE_EDITPROPERTYRECORD, {
      onError(error) {
        Alert.notice(`${error.message.replace("GraphQL error: ", "")}`);
      },
    });

  let editLog = "";
  const editProperty =
    courtArray.find((item) => item.value === data?.foreclosure.obj_court)
      ?.label +
    "(" +
    data?.foreclosure.obj_str +
    data?.foreclosure.obj_share +
    data?.foreclosure.obj_caseno +
    data?.foreclosure.obj_another +
    ")，" +
    "拍次：" +
    (data?.foreclosure.obj_time !== "0" ? data?.foreclosure.obj_time : "應買") +
    "\n" +
    (data?.foreclosure.obj_type === "H"
      ? data?.foreclosure.obj_city +
        data?.foreclosure.obj_area +
        data?.foreclosure.obj_address
      : data?.foreclosure.obj_city +
        data?.foreclosure.obj_area +
        data?.foreclosure.obj_section +
        "段" +
        data?.foreclosure.obj_section_s +
        (data?.foreclosure.obj_section_s ? "小段" : "") +
        data?.foreclosure.obj_landno +
        (data?.foreclosure.obj_landno ? "地號" : ""));
  function save(dataInput) {
    const foreclosureInput = {
      ...dataInput,
    };
    const originalData = data.foreclosure;
    delete originalData.obj_court;
    delete originalData.obj_another;
    delete originalData.obj_caseno;
    delete originalData.obj_debtor;
    delete originalData.obj_share;
    delete originalData.obj_str;
    delete originalData.images;
    delete originalData.obj_link;
    delete originalData.obj_creditor;
    delete originalData.__typename;

    if (JSON.stringify(dataInput) !== JSON.stringify(originalData)) {
      const dataInputKeys = Object.keys(dataInput);
      dataInputKeys.forEach((item) => {
        if (String(dataInput[item]) !== String(originalData[item])) {
          switch (item) {
            case "obj_creditor":
              editLog += "拍賣原因：" + dataInput[item] + ",";
              break;
            case "obj_debtor":
              editLog += "債務人：" + dataInput[item] + ",";
              break;
            case "obj_city":
              editLog += "縣市：" + dataInput[item] + ",";
              break;
            case "obj_area":
              editLog += "區域：" + dataInput[item] + ",";
              break;
            case "obj_section":
              editLog += "段：" + dataInput[item] + ",";
              break;
            case "obj_section_s":
              editLog += "小段：" + dataInput[item] + ",";
              break;
            case "obj_landno":
              editLog += "地號：" + dataInput[item] + ",";
              break;
            case "obj_address":
              editLog += "地址：" + dataInput[item] + ",";
              break;
            case "obj_time":
              editLog += "拍次：" + dataInput[item] + ",";
              break;
            case "obj_total_floor":
              editLog += "總建坪：" + dataInput[item] + ",";
              break;
            case "obj_land_floor":
              editLog += "地坪：" + dataInput[item] + ",";
              break;
            case "obj_build_floor":
              editLog += "主建坪：" + dataInput[item] + ",";
              break;
            case "obj_s_floor":
              editLog += "附建坪：" + dataInput[item] + ",";
              break;
            case "obj_add_floor":
              editLog += "增建坪：" + dataInput[item] + ",";
              break;
            case "obj_c_floor":
              editLog += "公設坪：" + dataInput[item] + ",";
              break;
            case "obj_margin":
              editLog += "保證金：" + dataInput[item] + ",";
              break;
            case "obj_price":
              editLog += "底價：" + dataInput[item] + ",";
              break;
            case "obj_land_data":
              editLog += "土地資訊：" + dataInput[item] + ",";
              break;
            case "obj_build_data":
              editLog += "建物資訊：" + dataInput[item] + ",";
              break;
            case "obj_bulletin_data":
              editLog += "公告筆錄：" + dataInput[item] + ",";
              break;
            case "obj_type":
              editLog +=
                "類別：" + `${dataInput[item] === "H" ? "建物" : "土地"}` + ",";
              break;
            case "obj_patterns":
              editLog += "型別：" + dataInput[item] + ",";
              break;
            case "obj_date_ymd":
              editLog +=
                "投標日期：" +
                moment(dataInput[item]).format("yyyy-MM-DD") +
                ",";
              break;
            case "obj_date_hi":
              editLog +=
                "投標時間：" + moment(dataInput[item]).format("HH:mm") + ",";
              break;
          }
        }
      });
      saveEditPropertyRecord({
        variables: {
          foreclosureId,
          editProperty,
          editLog,
        },
      });
    }
    saveForeclosure({ variables: { foreclosureInput } });
  }

  function getCaseName(obj_str, obj_share, obj_caseno, obj_another) {
    const share = Array.from(obj_share ?? []);
    const condition = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];
    let sourcefnp = false;
    if (share.indexOf("台") > -1 && share.indexOf("金") > -1) {
      sourcefnp = true;
    } else {
      share.forEach((item) => {
        condition.map((item2) => {
          if (item.indexOf(item2) > -1) sourcefnp = true;
        });
      });
    }

    return sourcefnp
      ? obj_str +
          "批號" +
          obj_caseno +
          (!!obj_another &&
          obj_another.indexOf("(") === -1 &&
          obj_another.indexOf("-") === -1
            ? "(" + obj_another + ")"
            : obj_another)
      : obj_str +
          obj_share +
          obj_caseno +
          (!!obj_another &&
          obj_another.indexOf("(") === -1 &&
          obj_another.indexOf("-") === -1
            ? "(" + obj_another + ")"
            : obj_another);
  }

  if (loading) {
    return (
      <Grid container item justify="center">
        <CircularProgress color="secondary" />
      </Grid>
    );
  } else {
    return data ? (
      <Card>
        <LoadingModal
          loading={saveForeclosureLoading || saveEditPropertyRecordLoading}
        />
        <CardContent>
          <Grid container spacing={1} direction="row">
            <Grid container item spacing={1}>
              <Grid item>
                <Typography style={{ color: "#ff1744", fontSize: 20 }}>
                  {"案號:" +
                    getCaseName(
                      data.foreclosure.obj_str,
                      data.foreclosure.obj_share,
                      data.foreclosure.obj_caseno,
                      data.foreclosure.obj_another
                    )}
                </Typography>
              </Grid>
              <Grid item>
                <Controller
                  name="obj_creditor"
                  control={control}
                  render={({ field }) => (
                    <TextField {...field} label="拍賣原因" fullWidth />
                  )}
                />
              </Grid>
              <Grid item>
                <Controller
                  name="obj_debtor"
                  control={control}
                  render={({ field }) => (
                    <TextField {...field} label="債務人" fullWidth />
                  )}
                />
              </Grid>
            </Grid>
            <Grid container item spacing={1}>
              <Grid item sm={1}>
                <Controller
                  name="obj_city"
                  control={control}
                  render={({ field }) => (
                    <TextField {...field} label="縣市" fullWidth />
                  )}
                />
              </Grid>
              <Grid item sm={1}>
                <Controller
                  name="obj_area"
                  control={control}
                  render={({ field }) => (
                    <TextField {...field} label="區域" fullWidth />
                  )}
                />
              </Grid>
              {objType === "H" ? (
                <Grid item sm={3}>
                  <Controller
                    name="obj_address"
                    control={control}
                    render={({ field }) => (
                      <TextField {...field} label="地址" fullWidth />
                    )}
                  />
                </Grid>
              ) : (
                <>
                  <Grid item sm={1}>
                    <Controller
                      name="obj_section"
                      control={control}
                      render={({ field }) => (
                        <TextField {...field} label="段" fullWidth />
                      )}
                    />
                  </Grid>
                  <Grid item sm={1}>
                    <Controller
                      name="obj_section_s"
                      control={control}
                      render={({ field }) => (
                        <TextField {...field} label="小段" fullWidth />
                      )}
                    />
                  </Grid>
                  <Grid item sm={1}>
                    <Controller
                      name="obj_landno"
                      control={control}
                      render={({ field }) => (
                        <TextField {...field} label="地號" fullWidth />
                      )}
                    />
                  </Grid>
                </>
              )}
              <Grid item sm={2}>
                <Controller
                  name="obj_type"
                  control={control}
                  render={({ field }) => (
                    <Select
                      items={typeArray}
                      value={
                        field.value
                          ? typeArray.find((item) => item.value === field.value)
                          : null
                      }
                      label="類別"
                      onChange={(e, v) => {
                        setValue("obj_type", v.value);
                      }}
                    />
                  )}
                />
              </Grid>
              {getValues("obj_type") === "H" && (
                <Grid item>
                  <Controller
                    name="obj_patterns"
                    control={control}
                    render={({ field }) => (
                      <TextField {...field} label="型別" fullWidth />
                    )}
                  />
                </Grid>
              )}
            </Grid>
          </Grid>
        </CardContent>
        <Divider />
        <CardContent>
          {isTable ? (
            <Table
              data={newData}
              tableWidth={2}
              header={[
                "投標日",
                "拍次",
                "總建坪",
                "地坪",
                "主建坪",
                "附建坪",
                "增建坪",
                "公設坪",
                "公告現值",
                "保證金",
                "底價",
              ]}
              columns={[
                (item) => (
                  <>
                    <Controller
                      name="obj_date_ymd"
                      control={control}
                      render={({ field }) => (
                        <DatePicker
                          {...field}
                          autoOk={true}
                          style={{ maxWidth: "115px" }}
                          format={"yyyy-MM-dd "}
                        />
                      )}
                    />
                    <Controller
                      name="obj_date_hi"
                      control={control}
                      render={({ field }) => (
                        <TimePicker
                          {...field}
                          style={{ maxWidth: "115px" }}
                          format={"HH:mm"}
                        />
                      )}
                    />
                  </>
                ),
                () => (
                  <Controller
                    name="obj_time"
                    control={control}
                    render={({ field }) => (
                      <TextField style={{ width: 40 }} {...field} fullWidth />
                    )}
                  />
                ),
                () => (
                  <Controller
                    name="obj_total_floor"
                    control={control}
                    render={({ field: { value } }) => (
                      <TextInput
                        style={{ width: 70 }}
                        value={value}
                        onChange={(e) => {
                          setValue("obj_total_floor", Number(e));
                        }}
                        fullWidth
                      />
                    )}
                  />
                ),
                () => (
                  <Controller
                    name="obj_land_floor"
                    control={control}
                    render={({ field: { value } }) => (
                      <TextInput
                        style={{ width: 70 }}
                        value={value}
                        onChange={(e) => {
                          setValue("obj_land_floor", Number(e));
                        }}
                        fullWidth
                      />
                    )}
                  />
                ),
                () => (
                  <Controller
                    name="obj_build_floor"
                    control={control}
                    render={({ field: { value } }) => (
                      <TextInput
                        style={{ width: 60 }}
                        value={value}
                        onChange={(e) => {
                          setValue("obj_build_floor", Number(e));
                        }}
                        fullWidth
                      />
                    )}
                  />
                ),
                () => (
                  <Controller
                    name="obj_s_floor"
                    control={control}
                    render={({ field: { value } }) => (
                      <TextInput
                        style={{ width: 60 }}
                        value={value}
                        onChange={(e) => {
                          setValue("obj_s_floor", Number(e));
                        }}
                        fullWidth
                      />
                    )}
                  />
                ),
                () => (
                  <Controller
                    name="obj_add_floor"
                    control={control}
                    render={({ field: { value } }) => (
                      <TextInput
                        style={{ width: 70 }}
                        value={value}
                        onChange={(e) => {
                          setValue("obj_add_floor", Number(e));
                        }}
                        fullWidth
                      />
                    )}
                  />
                ),
                () => (
                  <Controller
                    name="obj_c_floor"
                    control={control}
                    render={({ field: { value } }) => (
                      <TextInput
                        style={{ width: 70 }}
                        value={value}
                        onChange={(e) => {
                          setValue("obj_c_floor", Number(e));
                        }}
                        fullWidth
                      />
                    )}
                  />
                ),
                (item) => "公告現值",
                () => (
                  <Controller
                    name="obj_margin"
                    control={control}
                    render={({ field: { value } }) => (
                      <Grid container alignItems="flex-end">
                        <TextInput
                          style={{ width: 80 }}
                          value={value}
                          onChange={(e) => {
                            setValue("obj_margin", Number(e));
                          }}
                          fullWidth
                        />
                      </Grid>
                    )}
                  />
                ),
                () => (
                  <Controller
                    name="obj_price"
                    control={control}
                    render={({ field: { value } }) => (
                      <Grid Grid container alignItems="flex-end">
                        <TextInput
                          style={{ width: 70 }}
                          value={value}
                          onChange={(e) => {
                            setValue("obj_price", Number(e));
                          }}
                          fullWidth
                        />
                        萬
                      </Grid>
                    )}
                  />
                ),
              ]}
            />
          ) : (
            <Grid container spacing={1} direction="row">
              <Grid container xs={8}>
                <Typography color="primary">投標日:</Typography>
                <Typography>
                  {moment(data.foreclosure.obj_date_ymd).format("YYYY-MM-DD") +
                    "\u2002" +
                    moment(data.foreclosure.obj_date_hi).format("HH:mm")}
                </Typography>
              </Grid>
              <Grid container xs={4}>
                <Typography color="primary">拍次:</Typography>
                <Typography>{data.foreclosure.obj_time}</Typography>
              </Grid>
              <Grid container xs={4}>
                <Typography color="primary">總建坪:</Typography>
                <Typography>
                  {data.foreclosure.obj_type === "L"
                    ? 0
                    : data.foreclosure.obj_total_floor}
                </Typography>
              </Grid>
              <Grid container xs={4}>
                <Typography color="primary">地坪:</Typography>
                <Typography>{data.foreclosure.obj_land_floor}</Typography>
              </Grid>
              <Grid container xs={4}>
                <Typography color="primary">主建坪:</Typography>
                <Typography>{data.foreclosure.obj_build_floor}</Typography>
              </Grid>
              <Grid container xs={4}>
                <Typography color="primary">附建坪:</Typography>
                <Typography>{data.foreclosure.obj_s_floor}</Typography>
              </Grid>
              <Grid container xs={4}>
                <Typography color="primary">增建坪:</Typography>
                <Typography>{data.foreclosure.obj_add_floor}</Typography>
              </Grid>
              <Grid container xs={4}>
                <Typography color="primary">公設坪:</Typography>
                <Typography>{data.foreclosure.obj_c_floor}</Typography>
              </Grid>
              <Grid container xs={8}>
                <Typography color="primary">公告現值:</Typography>
                <Typography>公告現值</Typography>
              </Grid>
              <Grid container xs={6}>
                <Typography color="primary">保證金:</Typography>
                <Typography>
                  {(data.foreclosure.obj_margin / 10000).toFixed(2) + "萬"}
                </Typography>
              </Grid>
              <Grid container xs={6}>
                <Typography color="primary">底價:</Typography>
                <Typography>{data.foreclosure.obj_price + "萬"}</Typography>
              </Grid>
            </Grid>
          )}
        </CardContent>
        <Divider />
        <CardContent>
          <Grid container spacing={1}>
            <Grid item classes={{ root: classes.DocumentContainerCenter }}>
              <Typography>土地</Typography>
              <Typography style={{ color: "#3d5afe" }}>
                {data.foreclosure.obj_total_floor === 0
                  ? "建坪:" + 0
                  : "建坪:" +
                    (
                      data.foreclosure.obj_price /
                      data.foreclosure.obj_total_floor
                    ).toFixed(2) +
                    "萬" +
                    "\n"}
              </Typography>
              <Typography style={{ color: "#3d5afe" }}>
                {data.foreclosure.obj_land_floor === 0
                  ? "地坪:" + 0
                  : "地坪:" +
                    (
                      data.foreclosure.obj_price /
                      data.foreclosure.obj_land_floor
                    ).toFixed(2) +
                    "萬"}
              </Typography>
              {"\u2002"}
            </Grid>
            <Grid item>
              <Divider
                orientation="vertical"
                flexItem
                style={{ height: "100%" }}
              />
            </Grid>
            <Grid item style={{ flex: 1 }}>
              <Controller
                name="obj_land_data"
                control={control}
                render={({ field: { value, onChange } }) => (
                  <TextField
                    style={{ whiteSpace: "break-spaces" }}
                    value={value.replace(/<br>/g, "")}
                    onChange={onChange}
                    multiline
                    fullWidth
                  />
                )}
              />
            </Grid>
          </Grid>
        </CardContent>
        <Divider />
        <CardContent>
          <Grid container spacing={1}>
            <Grid item classes={{ root: classes.DocumentContainerCenter }}>
              <Typography>建物</Typography>
              <Typography style={{ color: "#3d5afe" }}>{`公設比:${
                Boolean(data.foreclosure.obj_c_floor) &&
                Boolean(data.foreclosure.obj_total_floor)
                  ? (
                      (data.foreclosure.obj_c_floor /
                        data.foreclosure.obj_total_floor) *
                      100
                    ).toFixed()
                  : 0
              }%`}</Typography>
              {"\u2002"}
            </Grid>
            <Grid item>
              <Divider
                orientation="vertical"
                flexItem
                style={{ height: "100%" }}
              />
            </Grid>
            <Grid item style={{ flex: 1 }}>
              <Controller
                name="obj_build_data"
                control={control}
                render={({ field: { value, onChange } }) => (
                  <TextField
                    style={{ whiteSpace: "break-spaces" }}
                    value={value.replace(/<br>| /g, "")}
                    onChange={onChange}
                    multiline
                    fullWidth
                  />
                )}
              />
            </Grid>
          </Grid>
        </CardContent>
        <Divider />
        <CardContent>
          <Grid container spacing={1}>
            <Grid item classes={{ root: classes.DocumentContainerCenter }}>
              <Typography>公告筆錄</Typography>
              {"\u2002"}
            </Grid>
            <Grid item>
              <Divider
                orientation="vertical"
                flexItem
                style={{ height: "100%" }}
              />
            </Grid>
            <Grid item style={{ flex: 1 }}>
              <Controller
                name="obj_bulletin_data"
                control={control}
                render={({ field: { value, onChange } }) => (
                  <TextField
                    style={{ whiteSpace: "break-spaces" }}
                    value={value.replace(/<br>| /g, "")}
                    onChange={onChange}
                    multiline
                    fullWidth
                  />
                )}
              />
            </Grid>
          </Grid>
        </CardContent>
        <Divider />
        <CardContent>
          <Grid container spacing={1}>
            <Box display="flex" alignItems="center" direction="row">
              <Box minWidth={100}>
                <Typography>土地增值</Typography>
              </Box>
              <Divider orientation="vertical" flexItem />
              {"\u2002"}
              <Box>
                <Typography></Typography>
              </Box>
            </Box>
          </Grid>
        </CardContent>
        <Divider />
        <CardActions>
          <Grid container spacing={1} justify="center">
            <Grid item>
              <Button
                color="primary"
                variant="contained"
                onPress={handleSubmit(save)}
              >
                儲存
              </Button>
            </Grid>
          </Grid>
        </CardActions>
      </Card>
    ) : (
      <Card></Card>
    );
  }
}
